import { apiFetch } from "../auth/apiClient";

export const operationsApi = {
  listStaff: () =>
    apiFetch("/api/operations/staff", {
      method: "GET",
      authRequired: true,
    }),
  listPastStaff: () =>
    apiFetch("/api/operations/staff/past", {
      method: "GET",
      authRequired: true,
    }),
  getStaff: (id) =>
    apiFetch(`/api/operations/staff/${id}`, {
      method: "GET",
      authRequired: true,
    }),
  addStaff: (body) =>
    apiFetch("/api/operations/staff", {
      method: "POST",
      authRequired: true,
      body,
    }),
  patchStaff: (id, body) =>
    apiFetch(`/api/operations/staff/${id}`, {
      method: "PATCH",
      authRequired: true,
      body,
    }),
  retireStaff: (id, body) =>
    apiFetch(`/api/operations/staff/${id}/retire`, {
      method: "POST",
      authRequired: true,
      body,
    }),
  listRoles: () =>
    apiFetch("/api/operations/roles", {
      method: "GET",
      authRequired: true,
    }),
  // ---- Duty roster (Phase 2) ----
  dutyToday: () =>
    apiFetch("/api/operations/duty/today", {
      method: "GET",
      authRequired: true,
    }),
  dutyForDate: (isoDate) =>
    apiFetch(`/api/operations/duty?on_date=${encodeURIComponent(isoDate)}`, {
      method: "GET",
      authRequired: true,
    }),
  replaceDuty: (body) =>
    apiFetch("/api/operations/duty", {
      method: "PUT",
      authRequired: true,
      body,
    }),
  onCall: ({ signal } = {}) =>
    apiFetch("/api/operations/on-call", {
      method: "GET",
      authRequired: true,
      signal,
    }),
};
